document.addEventListener("DOMContentLoaded", () => {

    //This method doesn't work without cookie acceptation, events aren't triggered
    window.WP_Grid_Builder && WP_Grid_Builder.on('init', function (wpgb) {
        console.log('WP_Grid_Builder init');
        wpgb.facets.on('loaded', function (facets) {
            console.log('WP_Grid_Builder facets loaded');
            if (wpgb.facets.hasFacet(18)) {
                console.log('WP_Grid_Builder facet 18');
                wpgb.facets.on('change', function (slug, values) {
                    console.log('WP_Grid_Builder facet 18 onChange');
                    if (slug === 'store_geoloc') {
                        console.log('WP_Grid_Builder facet store_geoloc');
                        wpgb.facets.setParams('trier_par_distance', ['geo_distance_asc']);
                    }
                });
            }
        });
    });

    //Force even if no cookies acceptation
    if (window.WP_Grid_Builder && WP_Grid_Builder.instances[1] && WP_Grid_Builder.instances[1].facets.hasFacet('store_geoloc')) {
        console.log('NC - WP_Grid_Builder');
        WP_Grid_Builder.instances[1].facets.on('change', function (slug, values) {
            console.log('NC - WP_Grid_Builder facet onChange');
            if (slug === 'store_geoloc') {
                console.log('NC - WP_Grid_Builder facet store_geoloc');
                WP_Grid_Builder.instances[1].facets.setParams('trier_par_distance', ['geo_distance_asc']);
            }
        });
    }
});